import { $window } from './bom';

// 获取 url 中的参数
// http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
export function getQueryString(name: string, url?: string) {
    if (!url) {
        url = $window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return results[2].replace(/\+/g, ' ');
}
function isEmptyObject(obj: { [key: string]: any }): boolean {
    for (const name in obj) {
        if (name) {
            return false;
        }
    }
    return true;
}
export function getCurrent(name: string, pathname?: string): boolean {
    if (!pathname) {
        pathname = $window.location.pathname;
    }

    const pathnameArr = pathname.split('/');
    if (pathnameArr.length > 1) {
        return pathnameArr[1] === name;
    }
    return false;
}
export function getMsgCnt(cnt: number | string, limit?: number) {
    limit = limit || 100;
    cnt = Number(cnt) || 0;
    return cnt > limit ? limit - 1 + '+' : cnt;
}

export interface ICancelableFunction {
    (...args: any[]): any;
    cancel: () => void;
    [props: string]: any;
}

/**
 * throttle
 */
 export const throttle = (fn: (...args: any[]) => any, wait: number, context?: any) => {
    let nextFn: number | any;
    let lastTimer: number;
    const newFunction = ((...args: any[]) => {
        if (!lastTimer) {
            fn.apply(context, args);
            lastTimer = Date.now();
        } else {
            clearTimeout(nextFn);
            nextFn = setTimeout(() => {
                if (Date.now() - lastTimer >= wait) {
                    fn.apply(context, args);
                    lastTimer = Date.now();
                }
            }, wait - (Date.now() - lastTimer));
        }
    }) as ICancelableFunction;

    newFunction.cancel = () => {
        clearTimeout(nextFn);
    };
    return newFunction;
};